import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { Modal } from "react-bootstrap";
import { crossIcon } from "../../assets";

class GenAIAnsweringDisclaimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: props.showPopup,
        }
    }
    render() {
        return (<><Modal
            show={this.state.showPopup}
            size="md"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="savePopUp"
            className="authoring-disclaimer-model"
            backdropClassName="document-processing-newthread-backdrop"
            scrollable={true}>
            <div style={{ padding: "0 0%" }}>
                <div style={{ fontSize: "14px",padding:"5px" }}>
                    <Modal.Body className="authoring-model-body-disclaimer">
                        <div onClick={e => this.props.handleDisclaimerClose()} className="authoring-model-body-disclaimer-cross" >
                            <img src={crossIcon} width={12} height={12} alt="Cross" />
                        </div>
                        <div className="authoring-model-body-content">
                            <span>
                                <b>As you engage with our Gen AI, please adhere to the following:</b>
                                <ul>
                                    <li>Gen AI should not be used to generate or distribute content violating our Code of Business Conduct, Privacy Policies, Information Asset Protection Policies (IAPPs), Open-Source Licensing Policy, and other relevant policies.</li>
                                    <li>Please remember that this platform is not intended to be used for GxP purposes.
                                    </li>
                                    <li>You are not allowed to upload personal information, sensitive information, proprietary content, or highly restricted data.
                                    </li>
                                    <li>Also, you may not upload any data for which you do not hold proper licensing from third parties and when using publicly available data sources, please confirm that you comply with the data owner's terms of use.
                                    </li>
                                    <li>Please review and comply with our <a className="authoring-model-body-content-link" href="https://jnj.sharepoint.com/sites/LawCenter/JJ%20Online%20Engagement%20Policy/Guidelines%20on%20the%20Responsible%20Use%20of%20Generative%20AI%20at%20Johnson%20and%20Johnson_FINAL.pdf" target="_blank" rel="noreferrer noopener" >Guidelines on the Responsible Use of Generative AI.</a>
                                    </li>
                                    <li>If you are generating images, please review and comply with our <a className="authoring-model-body-content-link" href="https://jnj.sharepoint.com/sites/LawCenter/LawCenter%20Trademark%20Resources/GenAI%20Image%20Generation%20Guidelines.pdf" target="_blank" rel="noreferrer noopener" >Usage Guidelines for GenAI Image Generation Tools.</a>
                                    </li>
                                </ul>
                                <span>Your interaction with Gen AI signifies your understanding and agreement to these terms.</span>

                            </span>
                        </div>

                    </Modal.Body>
                </div>
            </div>
        </Modal></>)
    }

}
export default withRouter(GenAIAnsweringDisclaimer);